
<template>
  <donut-chart08-template
    :board-ids="[244]"
    :data-type="dataType"
    field-code="facility-public"
    :graph-id="67"
    title="(공중(다중)이용시설) 중대재해 발생 현황"
    unit="건"/>
</template>

<script>
/* eslint-disable brace-style */
import DonutChart08Template from "@/views/graph/DonutChart08Template.vue";

export default {
  name: 'DonutChart67',
  components: {DonutChart08Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
